import Vue from 'vue'
import vuescroll from 'vuescroll'

// 你可以在这里设置全局配置
Vue.use(vuescroll, {
  ops: {} // 在这里设置全局默认配置
  // name: 'myScroll' // 在这里自定义组件名字，默认是vueScroll
})
Vue.prototype.$vuescrollConfig = {
  bar: {
    background: '#333333',
    keepShow: true
  }
}
